var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPinLocationSmall = function SvgPinLocationSmall(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.84048 12L7.54042 12.4L7.83591 12.6216L8.13462 12.4043L7.84048 12ZM7.84048 12C8.13462 12.4043 8.13472 12.4043 8.13483 12.4042L8.1351 12.404L8.13582 12.4035L8.13799 12.4019L8.14518 12.3966L8.17059 12.3776C8.19229 12.3614 8.22331 12.3378 8.26247 12.3074C8.34076 12.2467 8.45176 12.1585 8.58585 12.046C8.85356 11.8216 9.21585 11.4986 9.59475 11.1038C10.3382 10.3292 11.2061 9.21639 11.4792 7.98723L11.4793 7.98725L11.4814 7.97682C11.7561 6.60247 11.3425 5.46798 10.5954 4.68512C9.86246 3.917 8.82178 3.5 7.84049 3.5C5.8772 3.5 3.91435 5.18341 4.19296 7.69157C4.33312 8.95325 5.22125 10.1464 5.98915 10.976C6.38367 11.4022 6.76906 11.7562 7.05555 12.0035C7.19909 12.1274 7.31856 12.2252 7.40292 12.2926C7.44512 12.3263 7.47858 12.3525 7.50194 12.3705L7.52926 12.3915L7.53692 12.3973L7.5392 12.399L7.53994 12.3996L7.54021 12.3998C7.54032 12.3999 7.54042 12.4 7.84048 12Z",
    stroke: "#2F353B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.86671 8.23335C8.4374 8.23335 8.90004 7.77071 8.90004 7.20002C8.90004 6.62933 8.4374 6.16669 7.86671 6.16669C7.29601 6.16669 6.83337 6.62933 6.83337 7.20002C6.83337 7.77071 7.29601 8.23335 7.86671 8.23335Z",
    fill: "#E34B34",
    stroke: "#E34B34"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPinLocationSmall, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pin-location-small.f58256e3.svg";
export { ForwardRef as ReactComponent };